import { createAction } from '@reduxjs/toolkit';
import { User } from 'lib-shared-types-api';

const prefix = 'profile';

export const profileActions = {
  update: createAction<{ user: User }>(`${prefix}/update`),
};
